import { ResponsePayload, TokenPayload } from 'auth'
import Cookies from 'js-cookie'
import jwt_decode from 'jwt-decode'

export const setTokenCookies = (res: ResponsePayload) => {
    Cookies.set('access_token', res.access_token, {
        secure: true,
    })
    Cookies.set('refresh_token', res.refresh_token, {
        secure: true,
    })
}

export const getUserFromToken = () => {
    const access_token = Cookies.get('access_token')

    if (access_token === undefined) {
        return { username: '', roles: [] }
    } else {
        const decodedToken: TokenPayload = jwt_decode(access_token)
        return { username: decodedToken.sub, roles: decodedToken.roles }
    }
}
